/**
 * Selettore pack (1 / 3 / 6 bottiglie).
 *
 * Non crea varianti: scrive la quantità nel campo del form di acquisto, e lo
 * sconto lo applica al carrello la regola automatica configurata in admin.
 *
 * Vive come asset e non più dentro il blocco che lo usava, perché ora serve a
 * due punti diversi: il blocco della scheda prodotto e la hero del Gin.
 */

if (!customElements.get('format-selector')) {
  customElements.define(
    'format-selector',
    class FormatSelector extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (event) => {
          const input = event.target.closest('.format-selector__input');
          if (!input) return;
          this.#applyQuantity(parseInt(input.value, 10));
          this.#showDetail(input.value);
        });

        const checked = this.querySelector('.format-selector__input:checked');
        if (checked) this.#showDetail(checked.value);
      }

      /**
       * Variante a pillole: mostra la riga di riepilogo della scelta attiva e
       * ne riporta il totale nel pulsante di acquisto ("Aggiungi al carrello · €126,90").
       * @param {string} value
       */
      #showDetail(value) {
        const details = this.querySelectorAll('.format-selector__detail');
        if (!details.length) return;

        let total = '';
        details.forEach((detail) => {
          const active = detail.dataset.qty === value;
          detail.hidden = !active;
          if (active) total = detail.dataset.total || '';
        });

        if (!this.hasAttribute('data-cta-total') || !total) return;
        const scope = this.closest('.shopify-section') || document;
        const label = scope.querySelector('form[action*="/cart/add"] button[name="add"] .add-to-cart-text__content');
        if (!label) return;

        let slot = label.querySelector('.tanca-cta-total');
        if (!slot) {
          slot = document.createElement('span');
          slot.className = 'tanca-cta-total';
          label.append(slot);
        }
        slot.textContent = ` · ${total}`;
      }

      #applyQuantity(quantity) {
        if (!Number.isFinite(quantity)) return;

        const form =
          this.closest('form[action*="/cart/add"]') ||
          this.closest('.shopify-section, product-details, body');
        const field = form?.querySelector('input[name="quantity"]');
        if (!field) return;

        const max = parseInt(field.max, 10);
        field.value = Number.isFinite(max) && max > 0 ? Math.min(quantity, max) : quantity;
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
